var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37492 1V7.5C9.37492 7.59946 9.33541 7.69484 9.26509 7.76517C9.19476 7.83549 9.09938 7.875 8.99992 7.875C8.90047 7.875 8.80508 7.83549 8.73476 7.76517C8.66443 7.69484 8.62492 7.59946 8.62492 7.5V1.905L1.26492 9.265C1.19384 9.33124 1.09981 9.3673 1.00266 9.36559C0.905512 9.36387 0.812819 9.32452 0.744112 9.25581C0.675406 9.1871 0.63605 9.09441 0.634336 8.99726C0.632622 8.90011 0.668683 8.80609 0.734923 8.735L8.09492 1.375H2.49992C2.40047 1.375 2.30508 1.33549 2.23476 1.26516C2.16443 1.19484 2.12492 1.09946 2.12492 1C2.12492 0.900544 2.16443 0.805161 2.23476 0.734835C2.30508 0.664509 2.40047 0.625 2.49992 0.625H8.99992C9.09938 0.625 9.19476 0.664509 9.26509 0.734835C9.33541 0.805161 9.37492 0.900544 9.37492 1Z",
    fill: "#F1EFE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightArrow);
export default __webpack_public_path__ + "static/media/TopRightArrow.8056983e4a758714afd936c3199f19be.svg";
export { ForwardRef as ReactComponent };